import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import Typography from '@material-ui/core/Typography';
import useStyles from './title-style';

export default function Title(props) {
  const classes = useStyles();
  const {
    children, align, dark, noPadding, className, variant, textStyle, component,
  } = props;
  const setAlign = alignment => {
    switch (alignment) {
      case 'left':
        return classes.left;
      case 'right':
        return classes.right;
      case 'center':
        return classes.center;
      default:
        return classes.left;
    }
  };
  return (
    <div className={clsx(classes.title, setAlign(align), dark && classes.dark, noPadding ? classes.noPadding : {}, className)}>
      <Typography className={textStyle} variant={variant || 'h3'} component={component}>
        {children}
      </Typography>
    </div>
  );
}

Title.propTypes = {
  children: PropTypes.node.isRequired,
  align: PropTypes.string,
  dark: PropTypes.bool,
  noPadding: PropTypes.bool,
  className: PropTypes.string,
  textStyle: PropTypes.string,
  variant: PropTypes.string,
  component: PropTypes.string,

};

Title.defaultProps = {
  align: 'left',
  dark: false,
  noPadding: false,
  className: '',
  variant: null,
  textStyle: '',
  component: undefined,
};
